import { useState } from "react";
import { Dialog } from "primereact/dialog";

export const TextPopup = ({ text, headerText = "" }) => {
  const [visible, setVisible] = useState(false);
  const maxLength = 30;
  const isLong = text && text.length > maxLength;
  const shownText = isLong ? text.slice(0, maxLength) + "..." : text;

  return (
    <>
      <span
        style={{
          cursor: "pointer",
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
          display: "inline-block",
          maxWidth: "100%"
        }}
        onClick={() => setVisible(true)}
        title={isLong ? "Klik om alles te zien" : undefined}
      >
        {shownText}
      </span>
      <Dialog
        visible={visible}
        style={{ width: "40vw", maxWidth: 600 }}
        onHide={() => setVisible(false)}
        dismissableMask
        closable
        modal
        header={headerText}
      >
        <div style={{ whiteSpace: "pre-wrap", wordBreak: "break-word" }}>
          {text}
        </div>
      </Dialog>
    </>
  );
};
